import { setTheme } from "theme/default/setTheme";

export const setFontWeight400 = setTheme(({ theme }) => `font-weight: ${theme.fontWeightValues.font_weight_400}`);
